import { Injectable } from '@angular/core';
import { PlatformService } from '../platform.service';
@Injectable({ providedIn: 'root' })
export class ProviderCacheService {
  private readonly CACHE_PREFIX = 'provider_';
  constructor(
    private platform: PlatformService,
  ) {}
  set(providerId: string, data: any): void {
    if (this.platform.isBrowserPlatform()) {
      const cacheKey = this.CACHE_PREFIX + providerId;
      localStorage.setItem(cacheKey, JSON.stringify(data));
    }
  }

  get(providerId: string): any | null {
    if (this.platform.isBrowserPlatform()) {
      const cacheKey = this.CACHE_PREFIX + providerId;
      const cached = localStorage.getItem(cacheKey);
      return cached ? JSON.parse(cached) : null;
    }
  }
}
